import React from 'react'

export default function NoPage() {
    return (
        <div className='py-5'>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h1 className="text-center mb-0">ERROR 404! Page Not Found</h1>
                    </div>
                </div>
            </div>
        </div>
    )
}
